import React from 'react';
import { Link } from 'react-router-dom';
import { useJoinVisible } from '../../hooks/useJoinVisible';
import { CLUB } from '../../utils/constants';

/**
 * Hero mit dem Titelbild des Clubs.
 *
 * Das Bild liegt als echtes <img> im Markup statt als CSS-Hintergrund:
 * Nur so kann der Browser es als größtes Element der Seite frueh erkennen
 * und priorisiert laden (LCP), und nur so funktionieren srcset/WebP.
 *
 * Die Aufnahme zeigt die Autos in einem waagerechten Band über der
 * Bildmitte. Deshalb sitzt der Text UNTEN (über dem leeren Asphalt) und
 * object-position schiebt den Ausschnitt nach oben - sonst verdeckt die
 * Schrift genau die Fahrzeuge.
 */
export default function Hero() {
  const joinVisible = useJoinVisible();

  return (
    <section className="mt-hero">
      <picture className="mt-hero__media">
        <source
          type="image/webp"
          srcSet="/img/hero-800.webp 800w, /img/hero-1440.webp 1440w"
          sizes="100vw"
        />
        <img
          src="/img/hero-1440.jpg"
          srcSet="/img/hero-800.jpg 800w, /img/hero-1440.jpg 1440w"
          sizes="100vw"
          alt="Die Autos des Club Mini-Thrills nebeneinander aufgereiht bei Sonnenuntergang"
          fetchPriority="high"
        />
      </picture>

      <div className="mt-hero__scrim" aria-hidden="true" />

      <div className="mt-container mt-hero__inner">
        <p className="mt-hero__kicker">
          {CLUB.name}
          {CLUB.region ? ` · ${CLUB.region}` : ''}
        </p>

        <h1 className="mt-hero__title">{CLUB.claim}</h1>

        <hr className="mt-hero__rule" />

        <p className="mt-hero__lead">
          Wir sind ein bunter Haufen von Mini-Verrückten. Lerne uns kennen - und vielleicht
          bist du ja bald auch ein Teil der Crew.
        </p>

        {/* Wer schon dabei ist, braucht keine Einladung mehr - dann fuehrt
            der erste Knopf in den eigenen Bereich statt zur Registrierung.
            Bewusst getauscht statt weggelassen: Ein Hero mit nur noch einem
            Knopf wirkt wie ein halb fertiges Layout. */}
        <div className="mt-row mt-hero__actions">
          {joinVisible ? (
            <Link to="/mitglied-werden" className="mt-btn mt-btn--primary">
              Teil der Crew werden
            </Link>
          ) : (
            <Link to="/intern" className="mt-btn mt-btn--primary">
              Zu meinem Bereich
            </Link>
          )}
          <Link to="/termine" className="mt-btn mt-btn--ghost">
            Nächste Termine
          </Link>
        </div>
      </div>
    </section>
  );
}
